/* eslint-disable react/display-name */
import React, { useCallback, forwardRef, useEffect } from 'react';

import '../../../../../components/chargers/ChargerPanel/ChargerPanelStatus/chargerPanelStatus.css';

import { useLocation } from 'react-router-dom';
import { useAppDispatch } from '../../../../../rmsReduxStore/rmsReduxHooks';
import {  fetchChargerConnectorStatus } from '../../../../rmsReduxStore/acChargersRedux/acChargerCreators';
//import { useEffectOnce } from '../../../../../globalUtils/globalHooks';
import AcChargerStatusConnectorDetails from '../AcChargerStatusConnectorDetails';
import AcChargerStatusHistory from './AcChargerStatusHistory';



interface IChargerPanelStatusDashboard {
  contentHeight: number;
  // eslint-disable-next-line @typescript-eslint/ban-types
  apiCallForChargerStatusHistoryGraph: Function;
  // eslint-disable-next-line @typescript-eslint/ban-types
  apiCallbackForHistoryLogs: Function;
}

export type ChargerParameterRef = HTMLDivElement;

const AcChargerPanelStatusSecondOption = forwardRef<ChargerParameterRef, IChargerPanelStatusDashboard>(
  function (props) {
    const { contentHeight, apiCallForChargerStatusHistoryGraph, apiCallbackForHistoryLogs } = props;
    const dispatch = useAppDispatch();
    const location = useLocation();

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const asynchronousCallbacks = useCallback( () => {
       apiCallForChargerStatusHistoryGraph?.();
     
      dispatch(fetchChargerConnectorStatus({ chargerId: location?.state?.chargerId }));
      apiCallbackForHistoryLogs();
    }, [dispatch]);

    // useEffectOnce(() => {
    //  asynchronousCallbacks();
    // });
useEffect(()=>{
    apiCallForChargerStatusHistoryGraph?.();
    dispatch(fetchChargerConnectorStatus({ chargerId: location?.state?.chargerId }));
    apiCallbackForHistoryLogs();
},[])


    return (
      <div className='charger__panel__status__dashboard' style={{ height: `${contentHeight - 10}px` }}>
        <div className='charger__panel__status__dashboard-top'>
          <AcChargerStatusConnectorDetails />
        <AcChargerStatusHistory/>
        </div>
        {/* <ChargerStatusParameters ref={ref} /> */}
      </div>
    );
  }
);

export default AcChargerPanelStatusSecondOption;
